import { AppContext } from "App";
import Page from "components/base/Page";
import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import SubscriptionDetailLoader from "./SubscriptionDetailLoader";
import SubscriptionsPage from "./SubscriptionsPage";

const TeamsPage = () => {
  const { user } = useContext(AppContext);

  if (user.email !== "charles@waboba.com")
    return (
      <Page index title="Teams" testing>
        <div className="p-6">No Content at the moment.</div>
      </Page>
    );

  return (
    <Routes>
      <Route index element={<SubscriptionsPage />} />
      <Route path=":teamId/:channelId" element={<SubscriptionDetailLoader />} />
    </Routes>
  );
};

export default TeamsPage;
